module.exports = __webpack_public_path__ + "img/umajo-plus.5fed3525.png";